import classNames from 'classnames';
import { useCallback } from 'react';
import { toast } from 'react-toastify';
import { Heading } from 'yoso';
import { Milestone } from '~/components/Adventure/Adventure.hooks';
import { T } from '~/components/I18n';
import citizen from '~/components/Icon/Citizen/hatCitizen.png';
import lock from '~/components/Icon/lock.png';
import styles from './AdventureReward.module.scss';
export type AdventureRewardProps = Milestone & {
  className?: string;
  rewarded?: boolean;
  locked?: boolean;
};
export const AdventureReward = ({
  className,
  count,
  rewarded,
  locked,
  level,
}: AdventureRewardProps) => {
  const onClick = useCallback(() => {
    toast(<T name="citizen_adventure_join_locked_toast" options={[level]} />, {
      toastId: 'lockedReward',
      autoClose: 5000,
    });
  }, [level]);
  return (
    <div
      className={classNames(
        styles.root,
        { [styles.rewarded]: rewarded, [styles.locked]: locked },
        className
      )}
      onClick={locked && !rewarded ? onClick : undefined}>
      <img
        className={styles.icon}
        src={locked && !rewarded ? lock : citizen}
        alt="citizen reward"
        width="120"
        height="120"
      />
      <Heading level={5} className={styles.count}>
        <T name="citizen_adventure_join_num_my_trial" options={[count]} pre="nowrap" />
      </Heading>
      <p className={styles.description}>
        {rewarded ? (
          <T name="citizen_button_title_complete" />
        ) : locked ? (
          `Lv${level}`
        ) : (
          <T name="citizen_adventure_join_num_my_status2" />
        )}
      </p>
    </div>
  );
};
